export default {
  MANUAL: 'MANUAL',
  AUTO: 'AUTO',
};
